import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance, handleAxiosError, type ApiResponse } from "@/helpers/axios";

export const useAdminResendDemoInviteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (accountId: string) => {
      const response = await axiosInstance.post<ApiResponse<unknown>>(
        `/v2/accounts/${accountId}/send-demo-invite`
      );
      return response.data;
    },
    onSuccess: (_, accountId) => {
      void queryClient.invalidateQueries({ queryKey: ["account-admin-details", accountId] });
    },
  });
};

export const getResendDemoInviteErrorMessage = (error: unknown): string =>
  handleAxiosError(error)?.message ?? "Could not resend demo invitation email.";
